import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import { EMRConnectionLastImportType } from "src/services/emr/types";
import { formatRelativeTime } from "src/utils/emr/relativeTimeHelper";
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type LastImportType = {
  lastImport: EMRConnectionLastImportType | null | undefined;
};

const LastImport = ({ lastImport }: LastImportType) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const { mutedText, onSurface } = getSurfaceTokens(theme);

  return (
    <Box
      data-testid="last-import"
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        p: "8px",
        borderRadius: "4px",
        backgroundColor:
          theme.palette.mode === "dark" ? "#5B6D7A40" : "#5B6D7A20",
        flexBasis: "100%",
      }}
    >
      <Typography fontSize="12px" color={mutedText}>
        {t("Last import")}
      </Typography>
      {lastImport ? (
        <Box display="flex" gap="6px" flexWrap="wrap" alignItems="baseline">
          <Typography
            fontSize="14px"
            fontWeight={600}
            color={onSurface}
            title={new Date(lastImport.importedAt).toLocaleString()}
          >
            {formatRelativeTime(lastImport.importedAt, i18n?.language)}
          </Typography>
          <Typography
            fontSize="13px"
            color={mutedText}
            sx={{ minWidth: 0, wordBreak: "break-word" }}
          >
            {lastImport.title}
          </Typography>
        </Box>
      ) : (
        <Typography fontSize="14px" color={mutedText}>
          {t("No imports yet")}
        </Typography>
      )}
    </Box>
  );
};

export default LastImport;
